import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../../components/SEO';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import { Phone } from 'lucide-react';

const LocalCabMain = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const cities = [
    { name: 'Noida', displayName: 'Local Taxi Service In Noida' },
    { name: 'Rajpura', displayName: 'Local Taxi Service In Rajpura' },
    { name: 'Chandigarh', displayName: 'Local Taxi Service In Chandigarh' },
    { name: 'Delhi', displayName: 'Local Taxi Service In Delhi' },
    { name: 'Ghaziabad', displayName: 'Local Taxi Service In Ghaziabad' },
    { name: 'Faridabad', displayName: 'Local Taxi Service In Faridabad' },
    { name: 'Kharar', displayName: 'Local Taxi Service In Kharar' },
    { name: 'Mohali', displayName: 'Local Taxi Service In Mohali' },
    { name: 'Panchkula', displayName: 'Local Taxi Service In Panchkula' },
    { name: 'Zirakpur', displayName: 'Local Taxi Service In Zirakpur' },
    { name: 'Mohaliairport', displayName: 'Local Taxi Service In Mohali Airport' },
    { name: 'New-chandigarh', displayName: 'Local Taxi Service In New Chandigarh' },
    { name: 'Delhi-airport', displayName: 'Local Taxi Service In Delhi Airport' },
    { name: 'Greater-noida', displayName: 'Local Taxi Service In Greater Noida' },
    { name: 'Chandigarh-airport', displayName: 'Local Taxi Service In Chandigarh Airport' },
    { name: 'Gurgaon', displayName: 'Local Taxi Service In Gurgaon' }
  ];

  const handleViewCabs = (cityName) => {
    navigate(`/local-cab/${cityName?.toLowerCase()}`);
  };

  return (
    <>
      <SEO
        title="Local Cab Service From - Select a City to View Cabs | Advait Tour and Travels"
        description="Book local cab service from major cities. Reliable, convenient rides for hourly bookings. Professional drivers and affordable rates."
        keywords="local cab service, local taxi service, hourly cab booking, city taxi service"
        canonicalUrl={`${window.location?.origin}/local-cab`}
        ogTitle="Local Cab Service From - Select a City to View Cabs | Advait Tour and Travels"
        ogDescription="Book local cab service from major cities. Reliable, convenient rides for hourly bookings. Professional drivers and affordable rates."
        ogUrl={`${window.location?.origin}/local-cab`}
        structuredData={{
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Advait Tour and Travels",
          "description": "Local cab service from major cities"
        }}
      />

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="py-20">
          {/* Hero Section */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 py-16 mb-12">
            <div className="container mx-auto px-4">
              <h1 className="text-4xl md:text-5xl font-bold text-white text-center">
                Local Cab Service From
              </h1>
              <p className="text-xl text-white text-center mt-4">
                Select a City to View Cabs
              </p>
            </div>
          </div>

          {/* City Cards */}
          <div className="container mx-auto px-4 mb-16">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
              {cities?.map((city, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 p-6"
                >
                  <h3 className="text-xl font-bold text-gray-800 mb-4 text-center">
                    {city?.displayName}
                  </h3>
                  <button
                    onClick={() => handleViewCabs(city?.name)}
                    className="w-full py-3 bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold rounded-lg transition-colors duration-300"
                  >
                    VIEW CABS
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Contact Section */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 py-12">
            <div className="container mx-auto px-4 text-center">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                We're here for you 24/7!
              </h2>
              <p className="text-xl text-white mb-6">
                Give us a call anytime
              </p>
              <a
                href="tel:+917998666660"
                className="inline-flex items-center gap-3 px-8 py-4 bg-white text-blue-600 font-bold text-2xl rounded-full hover:bg-gray-100 transition-colors duration-300"
              >
                <Phone className="w-6 h-6" />
                +91-79986-66660
              </a>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default LocalCabMain;